import { ISchema, PaywallComponentProps } from '../../@types'
import { mergeDeep } from '@/helpers/utils'
import simple_premium_1m_9_99_1m_44_usd from '@/data/products/subscription/prd_sbY0NWq9GMkz'
import simple_premium_3m_19_99_3m_79_usd from '@/data/products/subscription/prd_kvFfWmOs3D4D'

export default (schema: ISchema): ISchema =>
	mergeDeep(
		{ ...schema },
		{
			config: {
				products: [
					{
						idents: {
							discounted: simple_premium_1m_9_99_1m_44_usd.ident,
							fallback: null,
						},
						default: true,
					},
					{
						idents: {
							discounted: simple_premium_3m_19_99_3m_79_usd.ident,
							fallback: null,
						},
					},
				],
			},
			components: {
				// срезаем первый продукт (1w) из items базы
				PaywallPlanPicker: (args): PaywallComponentProps.PlanPicker => {
					const base = schema.components.PaywallPlanPicker(args)
					return {
						...base,
						items: base.items.slice(1),
					}
				},
			},
		},
	)
